import { useEffect, useRef, useState } from 'react';

import { ButtonWithIcon } from 'components/UI/ButtonWithIcon/ButtonWithIcon';

import messageBoxStore from 'MessageBox/MessageBoxStore';

import { ApiError } from 'client';

import { downloadReports } from '../downloadReports';

import downloadIcon from 'assets/images/download.svg';

import './DownloadReportsButton.scss';

/** Первый в списке — он же формат по умолчанию на стороне API. */
const FORMATS = [
  { format: 'csv', title: 'CSV' },
  { format: 'json', title: 'JSON' },
];

/**
 * Кнопка выгрузки отчетов файлом. По клику открывает выбор формата.
 * @param {Object} obj
 * @param {Number} [obj.projectId] Отчеты только этого проекта. Без него — все отчеты пользователя.
 * @param {String} [obj.title] Подпись. Пустая строка — кнопка только с иконкой.
 * @param {String} [obj.ariaLabel]
 * @param {String} [obj.className] Достается кнопке, а не обертке: снаружи стилизуется сама кнопка.
 */
export function DownloadReportsButton({
  projectId,
  title = '',
  ariaLabel,
  className,
}) {
  const [isBusy, setIsBusy] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!isMenuOpen) return;

    function onDocumentMouseDown(e) {
      if (!rootRef.current?.contains(e.target)) setIsMenuOpen(false);
    }
    function onKeyDown(e) {
      if (e.key === 'Escape') setIsMenuOpen(false);
    }

    document.addEventListener('mousedown', onDocumentMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocumentMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isMenuOpen]);

  async function onFormatClick(format) {
    setIsMenuOpen(false);
    if (isBusy) return;

    setIsBusy(true);
    try {
      await downloadReports({ projectId, format });
    } catch (e) {
      if (e instanceof ApiError) {
        messageBoxStore.showError(e.message);
        return;
      }
      throw e;
    } finally {
      setIsBusy(false);
    }
  }

  return (
    <div className="download-reports" ref={rootRef}>
      <ButtonWithIcon
        className={`download-reports-button ${className || ''}`}
        title={title}
        icon={downloadIcon}
        onClick={() => setIsMenuOpen((open) => !open)}
        disabled={isBusy}
        ariaLabel={ariaLabel ?? 'Скачать отчеты'}
      />
      {isMenuOpen && (
        <div className="download-reports__menu" role="menu">
          {FORMATS.map((item) => (
            <button
              key={item.format}
              className="download-reports__menu-item"
              type="button"
              role="menuitem"
              onClick={() => onFormatClick(item.format)}
            >
              {item.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
